import React from 'react'

import HELPTEXT from '../../../business-const/HelpText/HelpText'

import LABEL from '../../../business-const/Label/Label'

import MESSAGE from '../../../business-const/Message/Message'

import {
    CLASSNAME
} from '../../../business-const/Style/Style'

import {
    tituloEstudoGarantiaCliente,
    tituloEstudoResponsabilidadeCliente,
    tituloEstudoGarantiaConjuge,
    tituloEstudoResponsabilidadeConjuge,
} from './EstudoService'

import {
    formataTableCellHeadExibeDadosTitulo,
    formataTableCellHeadExibeDadosTexto,
    formataTableCellHeadExibeDadosValorDestaque3,
    formataTableCellHeadExibeDadosValorQuebraEspecial,
} from '../../../business-components/Formata/Formata'

import {
    DivFormEstudo,
} from '../../../business-components/Div/Div'

import {
    TableExibeDados,
    TableHeadExibeDados,
    TableRowHeadExibeDados,
    TableBodyExibeDados,
    TableRowBodyExibeDados,
    TableCellBodyExibeDados,
} from '../../../business-components/Table/TableExibeDados'

import {
    SvgIconFinanciamento,
} from '../../../business-components/SvgIcon/SvgIconDespesasTotais/SvgIconDespesasTotais'

import {
    dadosCompletosCliente,
    dadosCompletosConjuge,
} from '../cliente-form/ClienteService'

import {
    relatorioModoApresentacao,
} from './EstudoService'

import {
    CardGridEstudoTabelaPadrao,
} from './EstudoComp'



const EstudoFormDespesasFinanciamento = ( { values, estudo, report, jsonConfiguracao, indInicial, indFinal } ) => {

    const DespesasFinanciamento = () => {

        let headList = [
            {
                colSpan: 5,
                headTitle: formataTableCellHeadExibeDadosTitulo(LABEL.tipoFinanciamento, report),
            },
            {
                colSpan: 4,
                headTitle: formataTableCellHeadExibeDadosValorQuebraEspecial(LABEL.valorMensal, report),
            },
            {
                colSpan: 3,
                headTitle: formataTableCellHeadExibeDadosTexto(LABEL.qtdeParcelas, report),
            },
            {
                colSpan: 2,
                headTitle: formataTableCellHeadExibeDadosTexto(LABEL.anoFinal, report),
            },
            {
                colSpan: 4,
                headTitle: formataTableCellHeadExibeDadosValorDestaque3(
                    LABEL.valorTotalParcelasAbreviado + "/ " + LABEL.valorSaldoDevedor, report),
            },
        ]

        if (dadosCompletosCliente(values)) {
            headList.push(
                {
                    colSpan: 4,
                    headTitle: formataTableCellHeadExibeDadosValorQuebraEspecial(
                                tituloEstudoResponsabilidadeCliente(values), report
                            ),
                },
                {
                    colSpan: 4,
                    headTitle: formataTableCellHeadExibeDadosValorQuebraEspecial(
                                tituloEstudoGarantiaCliente(values), report
                            ),
                },
            )
        }

        if (dadosCompletosConjuge(values)) {
            headList.push(
                {
                    colSpan: 4,
                    headTitle: formataTableCellHeadExibeDadosValorQuebraEspecial(
                                tituloEstudoResponsabilidadeConjuge(values), report
                            ),
                },
                {
                    colSpan: 4,
                    headTitle: formataTableCellHeadExibeDadosValorQuebraEspecial(
                                tituloEstudoGarantiaConjuge(values), report
                            ),
                },
            )
        }

        return (
            <TableExibeDados
                report={report}
            >
                <TableHeadExibeDados
                    report={report}
                >
                    <TableRowHeadExibeDados
                        dados={headList}
                    />
                </TableHeadExibeDados>

                <TableBodyExibeDados>
                    {estudo.current.financiamento?.map((item, ind) => {

                        let colSpan = 0

                        return (!indFinal || (ind >= indInicial && ind <= indFinal)) && (
                            <TableRowBodyExibeDados
                                key={ind}
                                report={report}
                            >
                                <TableCellBodyExibeDados
                                    colSpan={headList[colSpan++].colSpan}
                                    primeiraColuna={true}
                                >
                                    {item.descricao}
                                </TableCellBodyExibeDados>
                                
                                <TableCellBodyExibeDados
                                    colSpan={headList[colSpan++].colSpan}
                                >
                                    {item.valorMensal}
                                </TableCellBodyExibeDados>
                                
                                <TableCellBodyExibeDados
                                    colSpan={headList[colSpan++].colSpan}
                                >
                                    {item.qtdeParcelas}
                                </TableCellBodyExibeDados>
                                
                                <TableCellBodyExibeDados
                                    colSpan={headList[colSpan++].colSpan}
                                >
                                    {item.anoFinal}
                                </TableCellBodyExibeDados>

                                <TableCellBodyExibeDados
                                    colSpan={headList[colSpan++].colSpan}
                                >
                                    {item.valorTotalParcelasSaldoDevedor}
                                </TableCellBodyExibeDados>
                                        
                                {dadosCompletosCliente(values) && (
                                    <>
                                        <TableCellBodyExibeDados
                                            colSpan={headList[colSpan++].colSpan}
                                        >
                                            {item.valorResponsabilidadeCliente}
                                        </TableCellBodyExibeDados>
                                        
                                        <TableCellBodyExibeDados
                                            colSpan={headList[colSpan++].colSpan}
                                        >
                                            {item.valorGarantiaCliente}
                                        </TableCellBodyExibeDados>
                                    </>
                                )}
                                
                                {dadosCompletosConjuge(values) && (
                                    <>
                                        <TableCellBodyExibeDados
                                            colSpan={headList[colSpan++].colSpan}
                                        >
                                            {item.valorResponsabilidadeConjuge}
                                        </TableCellBodyExibeDados>

                                        <TableCellBodyExibeDados
                                            colSpan={headList[colSpan++].colSpan}
                                        >
                                            {item.valorGarantiaConjuge}
                                        </TableCellBodyExibeDados>
                                    </>
                                )}
                            </TableRowBodyExibeDados>
                        )
                    })}
                </TableBodyExibeDados>
            </TableExibeDados>
        )
    }

    return (
        <DivFormEstudo>
            {report || relatorioModoApresentacao(values)
                ?
                    //<div
                        //className={(relatorioModoApresentacao(values) ? 'mt-10 ml-5 mr-5' : '')} // mudança da fonte: acrescentou mt-10
                    //>
                    <>
                        <div
                            className={CLASSNAME().formataReportDetalhamento}
                            align='left'
                        >
                            {jsonConfiguracao && jsonConfiguracao.estudoReportDetalhamentoFinanciamentoTextoCabecalho
                                ?
                                    <>
                                        {jsonConfiguracao.estudoReportDetalhamentoFinanciamentoTextoCabecalho}
                                        <br/>
                                        <br/>
                                        <br/>
                                    </>
                                :
                                    MESSAGE().estudoReportDetalhamentoFinanciamentoTextoCabecalho
                            }
                        </div>

                        <DespesasFinanciamento />
                    </>
                    //</div>
                :
                    <CardGridEstudoTabelaPadrao
                        values={values}
                        SvgIcon={SvgIconFinanciamento}
                        label={LABEL.financiamento}
                        helpTextMorte={HELPTEXT.estudoFinanciamentoMorte}
                        helpTextInvalidez={HELPTEXT.estudoFinanciamentoInvalidez}
                        component={<DespesasFinanciamento/>}
                        popup={true}
                    />
            }
        </DivFormEstudo>
    )
}

export default EstudoFormDespesasFinanciamento